import { atom } from 'recoil';
import { TUserState } from '@metadata';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'global-persist',
  storage: localStorage,
});

const globalState = atom<TUserState>({
  key: 'globalState',
  default: {
    UserInformation: {
      regUserId: '',
      regUserName: '',
      user_nm: '',
      userId: '',
      ofcNm: '',
      CompanyID: '',
      CompanyName: '',
      ServiceID: '',
      token: '',
      ctpvNm: '',
      deptNm: '',
      use_yn: '',
      sso_yn: '',
      login_type: '',
    },
    userService: {
      ADMIN: '',
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    stae: {
      ADMIN: '',
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    groupId: {
      CROPS: '',
      FORST: '',
      OCEAN: '',
      VEHICLE: '',
    },
    cookieId: '',
    rememberId: '',
    isLogin: false,
    loginTime: 0,
    currentPage: {
      title: '',
      url: '/',
    },
  },
  // effects: [getLocalStorageSession()],
  effects: [persistAtom],
});

export default globalState;
